/*=========================================================================================
  File Name: moduleBedTypesMutations.js
  Description: BedTypes Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {
   
  };
  